import { useEffect } from 'react';
import styles from '../bookings/list.module.css';
import axios from 'axios';
import { authData } from "../../components/getAuth";
import { useForm } from "react-hook-form";

const NotePopup = ({ setModalShow, noteItem, bookingId, editNote, setLoading }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    mode: 'onChange',
    defaultValues: {
      delivery_note: ''
    }
  });

  useEffect(() => {
    if (editNote) {
      setValue('delivery_note', editNote);
    }
  }, [editNote, setValue]);

  const onSubmitLocal = (data) => {
    setModalShow(false);
    setLoading(true);

    axios.post(process.env.REACT_APP_API_URL + 'v1/update-bookings/' + bookingId, data, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then(response => {
      setLoading(false);
      if (response.data.status === 'SUCCESS') {
        if (editNote) {
          noteItem('Delivery note updated successfully.', response.data.data);
        } else {
          noteItem('Delivery note added successfully.', response.data.data);
        }
      }
    }).catch(error => {
      setLoading(false);
    });
  }

  return (<>
    <div className={`${styles.FullDiv}`}>
      <form onSubmit={handleSubmit(onSubmitLocal)}>
        <div className={`${styles.FormGroupFull}`}>
          <label className={`${styles.FormLabel}`}>Delivery Note*</label>
          <textarea className={`${styles.FormControlTextArea}`} {...register("delivery_note", { required: 'Please enter note' })}></textarea>
          {errors.delivery_note && <span className={`${styles.ErrorM}`}>{errors.delivery_note.message}</span>}
        </div>
        <div className={`${styles.FormButtonArea}`}>
          <input className={`${styles.CancelBU}`} value="Cancel" type="button" onClick={(e) => { setModalShow(false); }} />
          <input className={`${styles.SubmitBU}`} value={editNote ? "Update" : "Add"} type="submit" />
        </div>
      </form>
    </div>
  </>)
}

export default NotePopup;